/**
 * 휴일 시드 — `holiday` 는 하루에 한 행이므로 연휴는 날짜마다 한 행씩 깔린다.
 *
 * 근무일 판정(`./seed.ts` 의 workdays)이 이 목록을 쓰고, 근태 시드도 같은 목록으로 휴가 일수를
 * 센다. 그래서 둘 다 import 할 수 있도록 따로 둔다 — 서로를 import 하면 순환이 된다.
 */
import type { Holiday, HolidayKind } from "@/types";

const HOLIDAY_SEED: { from: string; to?: string; name: string; kind: HolidayKind }[] = [
  { from: "2026-08-15", name: "광복절", kind: "public" },
  { from: "2026-08-17", name: "대체공휴일", kind: "substitute" },
  { from: "2026-09-24", to: "2026-09-26", name: "추석 연휴", kind: "public" },
  { from: "2026-10-03", name: "개천절", kind: "public" },
  { from: "2026-10-09", name: "한글날", kind: "public" },
  { from: "2026-12-31", name: "종무일", kind: "company" },
];

/** 다음 날 — 연휴를 날짜마다 펼칠 때 쓴다. */
export const nextDay = (date: string) =>
  new Date(Date.parse(`${date}T00:00:00Z`) + 86_400_000).toISOString().slice(0, 10);

export const holidays: Holiday[] = HOLIDAY_SEED.flatMap((seed) => {
  const rows: Holiday[] = [];
  for (let day = seed.from; day <= (seed.to ?? seed.from); day = nextDay(day))
    rows.push({ holiday_date: day, name: seed.name, kind: seed.kind });
  return rows;
});

export const holidayDates = new Set(holidays.map((holiday) => holiday.holiday_date));
